import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import Text from 'components/Text/Text';
import style from './ImportantMessagesField.module.scss';

export const ImportantMessagesField = () => {
	const { androidWatches } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="importantMessagesLabel" theme="neutralLight" size="xs" />
			<div className={style.importantMessagesList}>
				{androidWatches?.importantMessages.length ? (
					androidWatches.importantMessages.map((el) => {
						return (
							<div key={el} className={style.item}>
								<div className={style.dot} />
								<Text translationKey={el} asFragment={true} />
							</div>
						);
					})
				) : (
					<Text translationNameSpace="form" translationKey="-" />
				)}
			</div>
		</div>
	);
};
